import axios from 'axios'
// import router from '../router/router'
// import store from '../store/store'
// import { loginOut } from '@/store/types'
import { Notification, MessageBox, Message } from 'element-ui'
// import store from '@/store'
// import { getToken } from '../utils/auth'
import errorCode from '@/utils/errorCode'
axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'
const axiosInstance = axios.create({
  headers: {
    'Content-Type': 'application/json; charset=UTF-8',
    // Authorization: getToken()
    // 'Authorization': ""
  },
  // baseURL: "https://community.qtechglobal.com/wechat_qt",
  // baseURL: "https://qt.qtechglobal.com/wechat_qt",
  // baseURL: "http://10.170.3.69:8980/wechat_qt",
  // baseURL: "http://localhost:8980/wechat_qt",
  // baseURL: "http://10.170.3.69:8989/QHR",
  // baseURL: "http://10.170.3.69:8989/",
  // baseURL:'http://10.170.89.38:8081',
  baseURL: "http://openapi.qtechglobal.com:8003/",
  withCredentials: true,
  timeout: 10000
  // // crossDomain: true,
  // timeout: 2500
});

// request拦截器
axiosInstance.interceptors.request.use(config => {
  // 是否需要设置 token
  // const isToken = (config.headers || {}).isToken === false
  // if (getToken() && !isToken) {
  //   // config.headers['Authorization'] = 'Bearer ' + getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
  //   config.headers['Authorization'] = getToken()
  // }
  // get请求映射params参数
  if (config.method === 'get' && config.params) {
    let url = config.url + '?';
    for (const propName of Object.keys(config.params)) {
      const value = config.params[propName];
      var part = encodeURIComponent(propName) + "=";
      if (value !== null && typeof(value) !== "undefined") {
        if (typeof value === 'object') {
          for (const key of Object.keys(value)) {
            let params = propName + '[' + key + ']';
            var subPart = encodeURIComponent(params) + "=";
            url += subPart + encodeURIComponent(value[key]) + "&";
          }
        } else {
          url += part + encodeURIComponent(value) + "&";
        }
      }
    }
    url = url.slice(0, -1);
    config.params = {};
    config.url = url;
  }
  return config
}, error => {
    console.log(error)
    Promise.reject(error)
})

// 响应拦截器
axiosInstance.interceptors.response.use(res => {
    // 未设置状态码则默认成功状态
    const code = res.data.code || 200;
    // 获取错误信息
    const msg = errorCode[code] || res.data.message || res.data.msg || errorCode['default']
    if (code === 401) {
      MessageBox.confirm('登录状态已过期，您可以继续留在该页面，或者重新登录', '系统提示', {
          confirmButtonText: '重新登录',
          cancelButtonText: '取消',
          type: 'warning'
        }
      ).then(() => {
        store.dispatch('LogOut').then(() => {
          location.href = '/index';
        })
      }).catch(() => {});
    } else if (code === 500) {
      Message({
        message: msg,
        type: 'error'
      })
      return Promise.reject(new Error(msg))
    }else if (code !== 200 && code !== 200102 && code !== 200108) {
      Notification.error({
        title: msg
      })
      return Promise.reject('error')
    } else {
      return res.data
    }
  },
  error => {
    console.log('err' + error)
    let { message } = error;
    if (message == "Network Error") {
      message = "后端接口连接异常";
    }
    else if (message.includes("timeout")) {
      message = "系统接口请求超时";
    }
    else if (message.includes("Request failed with status code")) {
      message = "系统接口" + message.substr(message.length - 3) + "异常";
    }
    Message({
      message: message,
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)

export default axiosInstance



// WEBPACK FOOTER //
// ./src/axios/axios.js